import {
    ROUTES_REPORTS_2K_TEST_GROUP,
    ROUTES_REPORTS_2K_TEST_INDIVIDUAL,
    ROUTES_REPORTS_6K_TEST_GROUP,
    ROUTES_REPORTS_6K_TEST_INDIVIDUAL,
    ROUTES_REPORTS_5K_TEST_GROUP,
    ROUTES_REPORTS_5K_TEST_INDIVIDUAL,
    ROUTES_REPORTS_STEP_TEST_GROUP,
    ROUTES_REPORTS_STEP_TEST_INDIVIDUAL,
    ROUTES_REPORTS_VO2_TEST_GROUP,
    ROUTES_REPORTS_VO2_TEST_INDIVIDUAL
} from '@/constants/routes';
import store from '@/store';
import { guardRoute } from '@/router';

const ReportsStepTestGroup = () =>
    import(/*webpackChunkName: 'reports-drv'*/ '@/components/reports/drv/step-tests/group/StepTests.vue');
const ReportsStepTestIndividual = () =>
    import(/*webpackChunkName: 'reports-drv'*/ '@/components/reports/drv/step-tests/individual/StepTests.vue');
const ReportsVo2TestGroup = () =>
    import(/*webpackChunkName: 'reports-drv'*/ '@/components/reports/drv/vo2-tests/group/Vo2Tests.vue');
const ReportsVo2TestIndividual = () =>
    import(/*webpackChunkName: 'reports-drv'*/ '@/components/reports/drv/vo2-tests/individual/Vo2Tests.vue');
const Reports2kTestGroup = () =>
    import(/*webpackChunkName: 'reports-drv'*/ '@/components/reports/drv/2k-tests/group/2kTests.vue');
const Reports2kTestIndividual = () =>
    import(/*webpackChunkName: 'reports-drv'*/ '@/components/reports/drv/2k-tests/individual/2kTests.vue');
const Reports6kTestGroup = () =>
    import(/*webpackChunkName: 'reports-drv'*/ '@/components/reports/drv/6k-tests/group/6kTests.vue');
const Reports6kTestIndividual = () =>
    import(/*webpackChunkName: 'reports-drv'*/ '@/components/reports/drv/6k-tests/individual/6kTests.vue');
const Reports5kTestGroup = () =>
    import(/*webpackChunkName: 'reports-drv'*/ '@/components/reports/drv/5k-tests/group/5kTests.vue');
const Reports5kTestIndividual = () =>
    import(/*webpackChunkName: 'reports-drv'*/ '@/components/reports/drv/5k-tests/individual/5kTests.vue');

export const REPORTS_ROUTES_DRV = [
    {
        name: ROUTES_REPORTS_STEP_TEST_GROUP,
        path: 'step-tests',
        beforeEnter: guardRouteStepTests,
        component: ReportsStepTestGroup
    },
    {
        name: ROUTES_REPORTS_STEP_TEST_INDIVIDUAL,
        path: 'step-tests/:id',
        beforeEnter: guardRouteStepTestsIndividual,
        component: ReportsStepTestIndividual
    },
    {
        name: ROUTES_REPORTS_VO2_TEST_GROUP,
        path: 'vo2-tests',
        beforeEnter: guardRouteVo2Tests,
        component: ReportsVo2TestGroup
    },
    {
        name: ROUTES_REPORTS_VO2_TEST_INDIVIDUAL,
        path: 'vo2-tests/:id',
        beforeEnter: guardRouteVo2TestsIndividual,
        component: ReportsVo2TestIndividual
    },
    {
        name: ROUTES_REPORTS_2K_TEST_GROUP,
        path: '2k-tests',
        beforeEnter: guardRoute2kTests,
        component: Reports2kTestGroup
    },
    {
        name: ROUTES_REPORTS_2K_TEST_INDIVIDUAL,
        path: '2k-tests/:id',
        beforeEnter: guardRoute2kTests,
        component: Reports2kTestIndividual
    },
    {
        name: ROUTES_REPORTS_6K_TEST_GROUP,
        path: '6k-tests',
        beforeEnter: guardRoute6kTests,
        component: Reports6kTestGroup
    },
    {
        name: ROUTES_REPORTS_6K_TEST_INDIVIDUAL,
        path: '6k-tests/:id',
        beforeEnter: guardRoute6kTests,
        component: Reports6kTestIndividual
    },
    {
        name: ROUTES_REPORTS_5K_TEST_GROUP,
        path: '5k-tests',
        beforeEnter: guardRoute5kTests,
        component: Reports5kTestGroup
    },
    {
        name: ROUTES_REPORTS_5K_TEST_INDIVIDUAL,
        path: '5k-tests/:id',
        beforeEnter: guardRoute5kTests,
        component: Reports5kTestIndividual
    }
];

function guardRouteStepTests(to, from, next) {
    const notInFeatureSet = !store.getters['clubPermissions/canViewFeatureDrv'];
    const unauthorized = !store.getters['userPermissions/canViewAllMembersStepTest'];
    guardRoute(next, unauthorized, notInFeatureSet);
}

function guardRouteStepTestsIndividual(to, from, next) {
    const notInFeatureSet = !store.getters['clubPermissions/canViewFeatureDrv'];
    const ownProfile = store.getters['clubHelper/me'].id === Number(to.params.id);
    const userIsAthlete = store.getters.isCurrentUserAthleteOfSelectedClub;
    const unauthorized = (!ownProfile || !userIsAthlete) && !store.getters['userPermissions/canViewAllMembersStepTest'];
    guardRoute(next, unauthorized, notInFeatureSet);
}

function guardRouteVo2Tests(to, from, next) {
    const notInFeatureSet = !store.getters['clubPermissions/canViewFeatureDrv'];
    const unauthorized = !store.getters['userPermissions/canViewAllMembersVo2Test'];
    guardRoute(next, unauthorized, notInFeatureSet);
}

function guardRouteVo2TestsIndividual(to, from, next) {
    const notInFeatureSet = !store.getters['clubPermissions/canViewFeatureDrv'];
    const ownProfile = store.getters['clubHelper/me'].id === Number(to.params.id);
    const userIsAthlete = store.getters.isCurrentUserAthleteOfSelectedClub;
    const unauthorized = (!ownProfile || !userIsAthlete) && !store.getters['userPermissions/canViewAllMembersVo2Test'];
    guardRoute(next, unauthorized, notInFeatureSet);
}

function guardRoute2kTests(to, from, next) {
    const notInFeatureSet = !store.getters['clubPermissions/canViewFeatureDrv'];
    const ownProfile = store.getters['clubHelper/me'].id === Number(to.params.id);
    const userIsAthlete = store.getters.isCurrentUserAthleteOfSelectedClub;
    const unauthorized = (!ownProfile || !userIsAthlete) && !store.getters['userPermissions/canViewAllMembers2kTest'];
    guardRoute(next, unauthorized, notInFeatureSet);
}

function guardRoute6kTests(to, from, next) {
    const notInFeatureSet = !store.getters['clubPermissions/canViewFeatureDrv'];
    const ownProfile = store.getters['clubHelper/me'].id === Number(to.params.id);
    const userIsAthlete = store.getters.isCurrentUserAthleteOfSelectedClub;
    const unauthorized = (!ownProfile || !userIsAthlete) && !store.getters['userPermissions/canViewAllMembers6kTest'];
    guardRoute(next, unauthorized, notInFeatureSet);
}

function guardRoute5kTests(to, from, next) {
    const notInFeatureSet = !store.getters['clubPermissions/canViewFeatureDrv'];
    const ownProfile = store.getters['clubHelper/me'].id === Number(to.params.id);
    const userIsAthlete = store.getters.isCurrentUserAthleteOfSelectedClub;
    const unauthorized = (!ownProfile || !userIsAthlete) && !store.getters['userPermissions/canViewAllMembers5kTest'];
    guardRoute(next, unauthorized, notInFeatureSet);
}
